import React from "react";
import { Navigate } from "react-router-dom";
import PageLoader from "../components/Common/PageLoader";
import { useAuthorization } from "../hooks/useAuthorization";

const AuthorizedRoute = ({
    children,
    feature,
    permission,
    permissionsAny,
    fallback = "/home",
}) => {
    const { canAccess, loading } = useAuthorization();

    if (loading) {
        return <PageLoader />;
    }

    if (!canAccess({ feature, permission, permissionsAny })) {
        return <Navigate to={fallback} replace />;
    }

    return <>{children}</>;
};

export default AuthorizedRoute;
